import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {Router} from "@angular/router";
import {ButtonModule} from "primeng/button";
import {CommonModule} from "@angular/common";
import {ProgressBarModule} from "primeng/progressbar";
import {finalize, Observable, of} from "rxjs";
import {catchError} from "rxjs/operators";
import {RippleModule} from "primeng/ripple";
import {FlowMode} from "../../../dto/enum/flow.mode.enum";
import {FlowStateService} from "../../../services/flow.state.service";


@Component({
    selector: 'app-page-navigation-bar',
    standalone: true,
    imports: [ButtonModule,
        CommonModule, ProgressBarModule, RippleModule,

    ],
    templateUrl: './page-navigation-bar.component.html',
    styleUrls: ['./page-navigation-bar.component.scss']
})
export class PageNavigationBarComponent {
    @Input() previousPageURL: string = "";
    @Input() nextPageURL: string = "";
    @Input() customTitle: string = "";
    @Input() type: 'simple' | 'complete' = 'complete';
    @Input() value: number = 0;
    @Input() stepKey: string = '';
    @Input() flowMode: FlowMode = FlowMode.CREATE;

    @Output() goPrevious = new EventEmitter<void>();
    @Output() goNext = new EventEmitter<void>();
    @Output() saveAndExit = new EventEmitter<void>();

    loading = false;

    /** Barra fija al fondo del viewport solo en el wizard (type 'complete'). */
    @HostBinding('class.nav-fixed') get isFixedBar(): boolean {
        return this.type === 'complete';
    }

    /** "Guardar y salir": visible en EDIT, en address (donde se crea), o cuando la propiedad ya existe. */
    get showSaveExit(): boolean {
        return this.flowMode === FlowMode.EDIT
            || this.stepKey === 'address'
            || !!this.flowState.propertyId;
    }

    constructor(private router: Router, private flowState: FlowStateService) {}

    redirectPage(pageURL: string): void {
        if (pageURL) {
            this.router.navigate([pageURL]);
        }
    }

    onNextClick(): void {
        this.goNext.emit();
    }

    onBackClick(): void {
        this.goPrevious.emit();
    }

    onSaveClick(): void {
        this.saveAndExit.emit();
    }
}
